import React from 'react';
import { useDragLayer } from 'react-dnd';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var COLUMN_HEADER_DRAG_TYPE = 'COLUMN_HEADER';
function collectDragLayerProps(monitor) {
    return {
        item: monitor.getItem(),
        isDragging: monitor.isDragging(),
        currentOffset: monitor.getSourceClientOffset(),
        initialCursor: monitor.getInitialClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
    };
}
function getItemStyles(props) {
    var initialOffset = props.initialOffset, currentOffset = props.currentOffset, initialCursor = props.initialCursor;
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none'
        };
    }
    // Some magic numbers here to position the 'drag box' under the cursor so that the cursor is above the 'drag icon'
    var x = initialCursor.x + (currentOffset.x - initialOffset.x) - 20;
    var y = initialCursor.y + (currentOffset.y - initialOffset.y) - 26;
    var transform = "translate(" + x + "px, " + y + "px)";
    return {
        transform: transform,
        WebkitTransform: transform,
        width: props.item.width,
    };
}
var ColumnDragLayer = function () {
    var dragLayerProps = useDragLayer(collectDragLayerProps);
    var isDragging = dragLayerProps.isDragging, item = dragLayerProps.item;
    if (!isDragging || item.type !== COLUMN_HEADER_DRAG_TYPE) {
        return null;
    }
    return (React.createElement("div", { className: "customLayer" },
        React.createElement("div", { style: getItemStyles(dragLayerProps), className: "draggedCell" },
            React.createElement(AccurityIcon, { iconName: "mui:DragIndicator", fontSize: "small", className: 'dragDotsTableColumn' }),
            item.label)));
};
export default ColumnDragLayer;
//# sourceMappingURL=ColumnDragLayer.js.map